import React, { useEffect, useState, } from 'react'
import { useTranslation } from "react-i18next";
import { useDispatch } from 'react-redux';
import { breadcrumbAction, tabNavigationAction } from '../../../../_actions';
import QuestionnaireTemplateGrid from './QuestionnaireTemplateGrid';
import { getTemplateGridNavigationItem } from './utils';
import QuestionnaireTemplatesCreationDrawer from '../QuestionnaireTemplatesCreationDrawer/QuestionnaireTemplatesCreationDrawer';
import { useSelector } from 'react-redux';
import { apps, userAccountRoleConstants } from '../../../../_constants';
import { history } from '../../../../_helpers';

const QuestionnaireTemplate = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch()
    const [isToggleDrawer, setIsToggleDrawer] = useState(false);
    const { all = [], } = useSelector( (state) => state.buildings);
    const app = useSelector((state) => state.app);
    const isSiteManagerOrConstructionQuality = all.some(a => a.roles?.includes(userAccountRoleConstants.siteManager)) && app === apps.constructionQuality;  

    useEffect(() => {
        if (!isSiteManagerOrConstructionQuality) {
            history.push("/kwaliteitsborging");
        }
    }, [all, isSiteManagerOrConstructionQuality]);
    
    useEffect(() => {
        const SurveyQuestionTemplateNavigation = getTemplateGridNavigationItem(t)
        dispatch(tabNavigationAction.setNavigationTab(SurveyQuestionTemplateNavigation.tabs))
        dispatch(breadcrumbAction.setBreadcrumbItem(SurveyQuestionTemplateNavigation.breadCrumbs))
    }, [dispatch, t])

 
    const handleDrawerClose = () => {
        setIsToggleDrawer(false);
    };


    return (
        <>
            <QuestionnaireTemplateGrid setIsToggleDrawer={setIsToggleDrawer} />
            { isToggleDrawer && (
                <QuestionnaireTemplatesCreationDrawer
                    handleClose={()=>handleDrawerClose()}
                />
            )}
        </>
    )

}

export default QuestionnaireTemplate
